'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiThList = function TiThList(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm31.7 28.3h-11.7c-1.8 0-3.3 1.5-3.3 3.4s1.5 3.3 3.3 3.3h11.7c1.8 0 3.3-1.5 3.3-3.3s-1.5-3.4-3.3-3.4z m0-11.6h-11.7c-1.8 0-3.3 1.5-3.3 3.3s1.5 3.3 3.3 3.3h11.7c1.8 0 3.3-1.5 3.3-3.3s-1.5-3.3-3.3-3.3z m0-11.7h-11.7c-1.8 0-3.3 1.5-3.3 3.3s1.5 3.4 3.3 3.4h11.7c1.8 0 3.3-1.5 3.3-3.4s-1.5-3.3-3.3-3.3z m-19.2 26.7c0 2.3-1.9 4.1-4.2 4.1s-4.1-1.8-4.1-4.1c0-2.3 1.8-4.2 4.1-4.2s4.2 1.9 4.2 4.2z m0-11.7c0 2.3-1.9 4.2-4.2 4.2s-4.1-1.9-4.1-4.2c0-2.3 1.8-4.2 4.1-4.2s4.2 1.9 4.2 4.2z m0-11.7c0 2.3-1.9 4.2-4.2 4.2s-4.1-1.9-4.1-4.2c0-2.3 1.8-4.1 4.1-4.1s4.2 1.8 4.2 4.1z' })
        )
    );
};

exports.default = TiThList;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/th-list.js
// module id = 2049
// module chunks = 0